import { toValue } from 'vue'
import { defineStore } from 'pinia'
import Page from '@/classes/pages/Page'

export const usePageStore = defineStore('PageStore', {
  state: () => ({
    page: {},
    loader: false,
    error: {}
  }),
  getters: {
    getPage: state => ({ id }) => state.$getItem({
      resource: 'page',
      key: id,
      fetch: () => state.fetchPage({ id })
    })
  },
  actions: {
    async fetchPage ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/pages/${toValue(id)}`,
        resource: `page.${toValue(id)}`,
        model: Page
      })
    }
  }
})